import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector, Store } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { OrgState } from 'src/app/dashboard/stores/org';
import { NotificationModel } from 'src/app/models/notification.model';
import { OrgModel } from 'src/app/models/org.model';

import { NotificationAction } from './notification.actions';
import { NotificationService } from './notification.service';
import { NotificationStateModel } from './notification.state.model';

@State<NotificationStateModel>({
    name: 'notification',
    defaults: new NotificationStateModel(),
})
@Injectable()
export class NotificationState {
    constructor(
        private NotificationService: NotificationService,
        private store: Store
    ) {}

    @Selector()
    static getNotifications(state: NotificationStateModel) {
        return state.notifications;
    }

    @Selector()
    static unReadNotificationCount(state: NotificationStateModel) {
        if (state.unReadNotificationCount > 100) {
            return '99+';
        }
        return state.unReadNotificationCount;
    }

    @Selector()
    static unReadOnlineOrdersCounter(state: NotificationStateModel) {
        if (state.unReadOnlineOrdersCounter > 100) {
            return '99+';
        }
        return state.unReadOnlineOrdersCounter;
    }

    @Action(NotificationAction.GetNotifications)
    getNotifications(ctx: StateContext<NotificationStateModel>) {
        const state = ctx.getState();
        if (state.notifications) {
            if (state.notificationLimit > state.notifications.count && state.notificationLimit > 10) {
                ctx.patchState({
                    notificationLimit: state.notifications.count,
                });
            }
        }
        return this.NotificationService.getNotifications(state.notificationLimit, this.organization().id).pipe(
            tap((resp) => {
                ctx.patchState({
                    notifications: resp,
                });
            })
        );
    }

    @Action(NotificationAction.LoadMoreNotifications)
    loadMoreNotifications(ctx: StateContext<NotificationStateModel>) {
        const state = ctx.getState();
        if (state.notifications) {
            if (state.notificationLimit + 10 < state.notifications.count) {
                ctx.patchState({
                    notificationLimit: state.notificationLimit + 10,
                });
            } else {
                ctx.patchState({
                    notificationLimit: 10,
                });
            }
        }
        return this.NotificationService.getNotifications(ctx.getState().notificationLimit, this.organization().id).pipe(
            tap((resp) => {
                ctx.patchState({
                    notifications: resp,
                });
            })
        );
    }

    @Action(NotificationAction.ReadNotification)
    readNotification(ctx: StateContext<NotificationStateModel>, action: NotificationAction.ReadNotification) {
        const { notifications } = ctx.getState();
        return this.NotificationService.readNotification(action.payload, this.organization().id).pipe(
            tap((resp: NotificationModel[]) => {
                notifications.notification.forEach((item) => {
                    if (resp[0]) {
                        if (resp[0].id === item.id) {
                            item.is_read = 1;
                        }
                    }
                });
                ctx.patchState({
                    notifications: notifications,
                });
            })
        );
    }

    @Action(NotificationAction.ResetNotification)
    resetNotification(ctx: StateContext<NotificationStateModel>, action: NotificationAction.ResetNotification) {
        const organiztionId = action.payload;
        return this.NotificationService.resetNotification(organiztionId).pipe(
            tap(() => {
                ctx.dispatch(new NotificationAction.GetNotifications());
            })
        );
    }

    @Action(NotificationAction.GetNotificationUnReadCount)
    getNotificationUnReadCount(ctx: StateContext<NotificationStateModel>) {
        return this.NotificationService.getNotificationUnReadCount(this.organization().id).pipe(
            tap((resp: any) => {
                ctx.patchState({
                    unReadNotificationCount: +resp.notification,
                    unReadOnlineOrdersCounter: +resp.unread,
                });
            })
        );
    }

    organization(): OrgModel {
        return this.store.selectSnapshot(OrgState.org);
    }
}
